import React from 'react'
import { Disclosure as HeadlessUIDisclosure } from '@headlessui/react'
import { IconChevronDown } from '@paro.io/base-icons'
import { Text } from '../Text'
import classNames from 'classnames'

export type DisclosureItem = {
  title: string
  content?: React.ReactNode
}

export interface IDisclosure {
  items: DisclosureItem[]
  defaultOpen?: boolean
  maxWidth?: 'max-w-sm' | 'max-w-md' | 'max-w-lg' | 'max-w-xl' | 'max-w-none'
}

export const Disclosure = ({
  items,
  defaultOpen = true,
  maxWidth = 'max-w-md'
}: IDisclosure) => {
  return (
    <div>
      {items.map((item, index) => {
        return (
          <div className='w-full pt-1' key={index}>
            <div className={classNames(`w-full  rounded-p-1 ${maxWidth}`)}>
              <HeadlessUIDisclosure defaultOpen={defaultOpen}>
                {({ open }) => {
                  return (
                    <div>
                      <HeadlessUIDisclosure.Button
                        className={classNames(
                          'flex w-full justify-between  bg-white px-4 text-gray-700 py-2 rounded-t-md',
                          { 'rounded-md': !open }
                        )}
                      >
                        <Text className='font-bold capitalize'>
                          {item.title}
                        </Text>
                        <IconChevronDown
                          size='lg'
                          className={classNames('h-5 w-5 text-gray-700', {
                            'rotate-180 transform': open
                          })}
                        />
                      </HeadlessUIDisclosure.Button>
                      <HeadlessUIDisclosure.Panel>
                        <div className='w-full p-4 rounded-b-md bg-white'>
                          {item.content ? item.content : 'Not available'}
                        </div>
                      </HeadlessUIDisclosure.Panel>
                    </div>
                  )
                }}
              </HeadlessUIDisclosure>
            </div>
          </div>
        )
      })}
    </div>
  )
}
